export const FULFILLMENT_RANGES = [
  {
    range: [1, 2],
    label: 'Unfulfilled',
  },
  {
    range: [3, 5],
    label: 'Partially fulfilled',
  },
  {
    range: [6, 8],
    label: 'Mostly fulfilled',
  },
  {
    range: [9, 10],
    label: 'Fulfilled',
  },
];

export const getFulfillmentLabel = (fulfillment: number) => {
  if (fulfillment === 0) {
    return '';
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const { range, label } of FULFILLMENT_RANGES) {
    if (fulfillment <= range[1]) {
      return label;
    }
  }

  return '';
};
